import { apiGet } from "./base";

export const fetchReleaseInfo = async () => {
  const url = `/api/version/`;
  const response = await apiGet(url);
  return response.data;
};
